import axios from 'axios';
import Auth from 'dashboard/api/auth';

/**
 * Creates an authenticated axios instance with auth headers from cookies
 * @returns {axios.AxiosInstance} Configured axios instance
 */
export function createAuthAxios() {
  const http = axios.create();
  
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();

    http.defaults.headers.common['access-token'] = accessToken;
    http.defaults.headers.common['token-type'] = tokenType;
    http.defaults.headers.common.client = client;
    http.defaults.headers.common.expiry = expiry;
    http.defaults.headers.common.uid = uid;
  }

  return http;
}
